function Chip({ active, children, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center px-2.5 py-[5px] font-mono text-[11px] uppercase tracking-[0.5px] cursor-pointer transition-colors ${
        active
          ? 'bg-soft-ink text-soft-bg'
          : 'text-soft-dim border border-soft-rule hover:text-soft-ink'
      }`}
    >
      {children}
    </button>
  )
}

export default Chip
